import { MainTracker } from '../../../PixelTrackers/MainTracker';

export function sanitizeLink(url: string): string {
  try {
    const cleaned = url.replace(/^https?:\/\//, '');
    const parsed = new URL('https://' + cleaned);
    const host = parsed.hostname.replace(/^www\./, '');
    return host + parsed.pathname;
  } catch {
    return url.replace(/^https?:\/\//, '');
  }
}

let menuOpenFrom = 'Header button';

export function setMenuOpenFrom(value: string): void {
  menuOpenFrom = value;
}

interface MenuNavigationData {
  category?: string;
  sub_category?: string;
  carousel?: 'yes' | 'no';
  carousel_product_location?: number;
  carousel_product_price?: string;
  carousel_product_name?: string;
  carousel_product_discount?: string;
  button_label?: string;
  link?: string;
  top_category_test?: string;
}

export function trackMenuNavigation(data: MenuNavigationData): void {
  const carousel = data.carousel ?? 'no';

  const payload: Record<string, unknown> = {
    menu_open_from: menuOpenFrom,
    category: data.category ?? '',
    sub_category: data.sub_category ?? '',
    carousel,
    carousel_product_location: null,
    carousel_product_name: null,
    carousel_product_price: null,
    carousel_product_discount: null,
    button_label: data.button_label ?? '',
    top_category_test: data.top_category_test ?? 'control',
  };

  if (data.link) {
    payload.link = sanitizeLink(data.link);
  }

  if (carousel === 'yes') {
    payload.carousel_product_location = data.carousel_product_location ?? null;
    payload.carousel_product_name = data.carousel_product_name ?? '';
    payload.carousel_product_price = data.carousel_product_price ?? '';
    payload.carousel_product_discount = data.carousel_product_discount ?? '';
  }

  MainTracker.track('custom', 'CMS Menu Navigation', payload);
}
